(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["cs-ticket-system-main"] = factory();
	else
		root["cs-ticket-system-main"] = factory();
})(window, function() {
return 